import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sunstone/ui';
import { PageHeader } from '@/components/ui/PageHeader';
import { ThemeToggle } from '../components/ui/ThemeToggle';

export function PreferencesPage() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="Preferences"
        description="Customize your theme and personal display preferences."
      />

      <Card className="max-w-lg">
        <CardHeader>
          <CardTitle>Appearance</CardTitle>
          <CardDescription>
            Customize how Business AI Cloud Management looks on your device.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between rounded-lg border border-border p-4">
            <div className="space-y-0.5">
              <p className="text-base font-medium">Theme</p>
              <p className="text-sm text-muted-foreground">Select your preferred color theme.</p>
            </div>
            <ThemeToggle />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
